<!-- 车辆管理 -->

<template>
  <div id="vehicle">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
        <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#vehicle {
  height: 100%;
}
</style>
